import React from 'react';
import styles from './user_response.module.scss';
import { careProviderConfiguration } from '../../store';
import { useAtom } from 'jotai';
import styled from 'styled-components';

const Response = styled.div`
  background-color: ${props => props.color};
`;

interface UserResponseProps {
  text: string;
  questionIndex: number;
}

const UserResponse = React.forwardRef<HTMLDivElement, UserResponseProps>(
  ({ text, questionIndex }, ref) => {
    const [careProviderStyles] = useAtom(careProviderConfiguration);

    return (
      <Response
        ref={ref}
        className={styles.userResponse}
        color={careProviderStyles.colorPrimary}
        data-cy="user_response"
        data-cy-question-index={questionIndex}
      >
        {text}
      </Response>
    );
  },
);

UserResponse.displayName = 'UserResponse';
export default UserResponse;
